import React from "react";
import { fmtEuro, MONTHS_EL_SHORT } from "@/lib/format";
import {
  ResponsiveContainer, BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend,
} from "recharts";

const tip = { borderRadius: 12, border: "1px solid #E3DED4", fontSize: 12 };
const axis = { fontSize: 11, fill: "#6F6A60" };

export const RevenueChart = ({ data, year }) => (
  <ResponsiveContainer width="100%" height={260}>
    <BarChart data={(data || []).map((d) => ({ ...d, name: MONTHS_EL_SHORT[d.m] }))} margin={{ left: -10, right: 6 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="#E3DED4" vertical={false} />
      <XAxis dataKey="name" tick={axis} axisLine={false} tickLine={false} />
      <YAxis tick={axis} axisLine={false} tickLine={false} width={56} tickFormatter={(v) => `€${(v / 1000).toFixed(0)}k`} />
      <Tooltip formatter={(v) => fmtEuro(v)} contentStyle={tip} cursor={{ fill: "#F7F5F1" }} />
      <Legend wrapperStyle={{ fontSize: 11 }} iconType="circle" />
      <Bar dataKey="ly" name={String(year - 1)} fill="#D8D0C2" radius={[4, 4, 0, 0]} />
      <Bar dataKey="cur" name={String(year)} fill="#C86235" radius={[4, 4, 0, 0]} />
    </BarChart>
  </ResponsiveContainer>
);

export const OccupancyChart = ({ data, year }) => (
  <ResponsiveContainer width="100%" height={220}>
    <LineChart data={(data || []).map((d) => ({ ...d, name: MONTHS_EL_SHORT[d.m] }))} margin={{ left: 0, right: 6 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="#E3DED4" vertical={false} />
      <XAxis dataKey="name" tick={axis} axisLine={false} tickLine={false} />
      <YAxis tick={axis} axisLine={false} tickLine={false} width={44} domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
      <Tooltip formatter={(v) => `${v}%`} contentStyle={tip} />
      <Legend wrapperStyle={{ fontSize: 11 }} iconType="circle" />
      <Line type="monotone" dataKey="ly" name={String(year - 1)} stroke="#B9AE9A" strokeWidth={2} dot={false} strokeDasharray="4 4" />
      <Line type="monotone" dataKey="cur" name={String(year)} stroke="#6E7A63" strokeWidth={2.5} dot={{ r: 2.5 }} />
    </LineChart>
  </ResponsiveContainer>
);
